const da = {
   
    message: {
        title1: 'Fjernstyring af smarte hjem - teknologi, sikkerhed og ro i sindet',
        content1: 'AigoSmart hjælper dig med at fjernstyre og kontrollere hjemmets smarte apparater. Enhederne kan også registrere hinanden og reagere på hinandens handlinger. Med et enkelt tryk kan du aktivere forskellige apparater i hjemmet, så de indstilles til dine foruddefinerede tilstande og skabe en sikker og bekymringsfri smart hjem-oplevelse.',
        title2: "AigoSmart er et nyt undermærke af Aigostar",
        content2: "Produkterne sælges i øjeblikket til europæiske lande og områder som Spanien, Portugal, Frankrig, Italien, Holland, Tyskland, Finland, Danmark, Polen, Rusland, Grækenland, Østrig, Schweiz, Tjekkiet, Ungarn og Slovakiet.",
        content3: "AIGOSTAR har flere køkken- og strygeapparater, som konsekvent er blandt de ti bedst sælgende produkter.",
        content4: "Salgsrangering blandt de ti bedste.",
        title3: "Brand Hæder",
        content5: "Hurtig . Åben . Innovativ . Vedholdende",
        loading: 'Indlæser',
        submit: 'Indsend',
        contactUs: "Kontakt os",
        privacy: "Fortrolighedspolitik",
        policy: "Servicepolitik",
        download: "Download",
    },
    
    wisdomleads: {
        title1: 'Fjernstyring af smarte hjem - teknologi, sikkerhed og ro i sindet',
        content1: 'wisdomleads hjælper dig med at fjernstyre og kontrollere hjemmets smarte apparater. Enhederne kan også registrere hinanden og reagere på hinandens handlinger. Med et enkelt tryk kan du aktivere forskellige apparater i hjemmet, så de indstilles til dine foruddefinerede tilstande og skabe en sikker og bekymringsfri smart hjem-oplevelse.',
        title2: "wisdomleads er et nyt undermærke af Aigostar",
        content2: "Produkterne sælges i øjeblikket til europæiske lande og områder som Spanien, Portugal, Frankrig, Italien, Holland, Tyskland, Finland, Danmark, Polen, Rusland, Grækenland, Østrig, Schweiz, Tjekkiet, Ungarn og Slovakiet.",
        content3: "wisdomleads har flere køkken- og strygeapparater, som konsekvent er blandt de ti bedst sælgende produkter.",
        content4: "Salgsrangering blandt de ti bedste.",
        title3: "Brand Hæder",
        content5: "Hurtig . Åben . Innovativ . Vedholdende",
        loading: 'Indlæser',
        submit: 'Indsend',
        contactUs: "Kontakt os",
        privacy: "Fortrolighedspolitik",
        policy: "Servicepolitik",
        download: "Download",
    },
    

    v119: {
        password: "Adgangskode",
        back: "Tilbage",
        account: 'Indtast konto',
        VerifyAccount: "Bekræft konto",
        confire: "Bekræft",
        complete: "Fuldført",
        loginAccount: "Log ind på konto",
        VerifyCode: "Verifikationskode",
        preview: "Forrige",
        next: "Næste",
        enterEmail: "Indtast e-mail",
        phone: "Telefonlogin",
        email: "E-mail-login",
        pleaseenter: "Indtast venligst",
        emailError: "Fejl i e-mailformat",
        phoneError: "Fejl i telefonnummerformat",
        qcCodeError: "Forkert verifikationskode",
        sendCode: "Send verifikationskode",
        reSend: "Send igen",
        tip1: "Inden du indsender en anmodning om afmelding, vil platformen verificere følgende oplysninger for at sikre din konto- og ejendomssikkerhed:",
        tip2: "Kontoen er i en sikker tilstand",
        tip3: "Ingen følsomme operationer som binding af telefon/e-mail, ændring af adgangskode, skift af loginenhed osv. inden for de sidste 15 dage",
        tip4: "Kontoen har ingen aktive intelligente enheder",
        tip5: "Du er offline (eller har ikke bundet) intelligente enheder",
        tip6: "Kontoen har ingen økonomisk risiko",
        tip7: "Ingen følsomme operationer som ændring af adgangskode, ingen købshistorik, ingen bundne bankkort osv. inden for de sidste 15 dage",
        accountCancellation: "Kontoafmelding",
        tip8: "Tak for din vedvarende støtte. Desværre kan AigoSmart ikke fortsætte med at yde service for dig. Inden du afmelder kontoen, vil vi gennemgå dine kontoinformationer igen. Vær opmærksom på, at følgende oplysninger vil blive slettet efter en succesfuld afmelding.",
        tip9: "Tak for din vedvarende støtte. Desværre kan Wisdomleads ikke fortsætte med at yde service for dig. Inden du afmelder kontoen, vil vi gennemgå dine kontoinformationer igen. Vær opmærksom på, at følgende oplysninger vil blive slettet efter en succesfuld afmelding.",
        tip10: "1. Oplysninger om intelligente moduler, rum, hjem og enhedsforbindelser vil blive permanent slettet og kan ikke gendannes.",
        tip11: "2. Oplysninger om scenarier, automatiseringer, brugerdefinerede opskrifter osv. vil blive permanent slettet og kan ikke gendannes.",
        tip13: "3. Alle kontoinformationer, serviceoptegnelser, forbrugsdata osv. vil blive permanent slettet og kan ikke gendannes.",
        tip14: "4. Du vil ikke kunne logge ind eller bruge denne AigoSmart-konto. Dine familiemedlemmer/venner vil ikke kunne dele enheder med dig via denne konto.",
        tip14w: "4. Du vil ikke kunne logge ind eller bruge denne Wisdomleads-konto. Dine familiemedlemmer/venner vil ikke kunne dele enheder med dig via denne konto.",
        tip15: "5. Personlige oplysninger og historiske beskeder for din AigoSmart-konto (inklusive profilbillede, kaldenavn, enhedsadvarsler, platformmeddelelser, hjemmemeddelelser osv.) vil være uopretteligt tabt.",
        tip15w: "5. Personlige oplysninger og historiske beskeder for din Wisdomleads-konto (inklusive profilbillede, kaldenavn, enhedsadvarsler, platformmeddelelser, hjemmemeddelelser osv.) vil være uopretteligt tabt.",
        tip16: "6. Du skal omhyggeligt håndtere kontantsaldoen (point, medlemsniveau, kvalifikation, ordrer, rabatkuponer, rekvisitter og andre værdifulde tjenester) før afmelding af kontoen. Efter afmelding betragtes det som din egen beslutning, og du kan ikke fortsætte med at bruge disse tjenester. Du forstår og accepterer, at AigoSmart ikke kan hjælpe med at gendanne disse tjenester.",
        tip16w: "6. Du skal omhyggeligt håndtere kontantsaldoen (point, medlemsniveau, kvalifikation, ordrer, rabatkuponer, rekvisitter og andre værdifulde tjenester) før afmelding af kontoen. Efter afmelding betragtes det som din egen beslutning, og du kan ikke fortsætte med at bruge disse tjenester. Du forstår og accepterer, at Wisdomleads ikke kan hjælpe med at gendanne disse tjenester.",
        tip17: "Platformen vil behandle din anmodning inden for 15 dage og slette alle dine data. Undlad venligst at logge ind på platformen i disse 15 dage for at sikre en problemfri afmelding.",
        tip18: "Indtast verifikationskoden",
        tip12: "Du kan i øjeblikket ikke afmelde kontoen",
        tip20: "Forslag til platformen (valgfrit)",
        errorMsg1: "Brugeren eksisterer ikke",
        errorMsg2: "Brugeren har allerede ansøgt om afmelding",
        errorMsg3: "Brugeren har udført følsomme operationer inden for de sidste 15 dage, f.eks. ændring af adgangskode, skift af enhed osv. Afmelding er ikke tilladt",
        errorMsg4: "Forkert verifikationskode",
        tip21: "Vent venligst, der udføres en menneske-maskine-verifikation",
    }
    
   
    
}

export default da;